import type {
  LayoutRect,
  ViewerPosition,
} from '../contracts/models';

export interface PdfViewportDimensions {
  width: number;
  height: number;
}

export const getPdfDisplayDimensions = (
  pageDimensions: PdfViewportDimensions,
  cropRegion?: LayoutRect | null,
): PdfViewportDimensions =>
  cropRegion
    ? { width: cropRegion[2], height: cropRegion[3] }
    : pageDimensions;

export const calculatePdfFit = (
  container: PdfViewportDimensions,
  content: PdfViewportDimensions,
  padding = 32,
): { scale: number; position: ViewerPosition } => {
  const availableWidth = Math.max(1, container.width - padding * 2);
  const availableHeight = Math.max(1, container.height - padding * 2);
  const scale = Math.min(
    availableWidth / Math.max(1, content.width),
    availableHeight / Math.max(1, content.height),
  );
  return {
    scale,
    position: {
      x: (container.width - content.width * scale) / 2,
      y: (container.height - content.height * scale) / 2,
    },
  };
};

export const clientToPdfPoint = (
  client: ViewerPosition,
  containerOrigin: ViewerPosition,
  position: ViewerPosition,
  scale: number,
): ViewerPosition => ({
  x:
    (client.x - containerOrigin.x - position.x) /
    Math.max(scale, Number.EPSILON),
  y:
    (client.y - containerOrigin.y - position.y) /
    Math.max(scale, Number.EPSILON),
});
